"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/common-components/lib/markdown-options.ts
var MARKDOWN_OPTIONS = [
  "blockquote",
  "fence",
  "code",
  "heading",
  "paragraph",
  "backticks",
  "emphasis",
  "strikethrough",
  "image",
  "link",
  "text",
  "escape"
];



exports.MARKDOWN_OPTIONS = MARKDOWN_OPTIONS;
//# sourceMappingURL=chunk-THK2N22P.js.map